export default "__VITE_ASSET__CCom6_0v__"